import React from 'react';
import { useParams } from 'react-router-dom';
import { Typography, Box } from '@mui/joy';
import ClientAnalytics from '../components/ClientAnalytics';
import ClientPermitsTable from '../components/ClientPermitsTable';

const ClientProjectDetail = () => {
  const { id } = useParams();

  return (
    <Box sx={{ mt: 8 }}>
      <Box>
        <Typography level="h4" gutterBottom>
          Project Detail
        </Typography>
        <Typography level="body-md" sx={{ mb: 2 }}>
          Showing details for project ID: {id}
        </Typography>
        <Typography level="body-sm" sx={{ mb: 3 }}>
          This is where detailed project data will be displayed including timeline, status, files, and interactive maps.
        </Typography>

        <ClientAnalytics projectId={id} />
        <Box sx={{ mt: 4 }}>
          <Typography level="h5" gutterBottom>
            Permits for This Project
          </Typography>
          <ClientPermitsTable projectId={id} />
        </Box>
      </Box>
    </Box>
  );
};

export default ClientProjectDetail;
